import RefEditor from './RefEditor.vue';

export default {
  install: function (Vue) {
    Vue.component('ref-editor', RefEditor)
  }
}